export default __webpack_public_path__ + "static/media/graphic_3.2.53f682b1.svg";